export const PROGRAM_PROMPT = 'Не впевнені, яка програма підійде саме вам?';
export const TEXT_US =
    'Напишіть нам — ми разом підберемо те, що найкраще відповідає вашим потребам або потребам вашої дитини.';
export const COMMON_QUESTIONS = 'Часті питання';
export const PROGRAMS = 'Програми';
export const PROGRAMS_FOR_KIDS = 'Дитячі';
export const PROGRAMS_FOR_VETERANS = 'Ветеранські';
export const PROGRAMS_ALL = 'Всі';
export const CONTACT = "Зв'язатись";
export const ABOUT_PROGRAMS =
    'Наші програми — це про повернення до себе і віднайдення внутрішньої сили.' +
    ' Через коня, через тіло, через простір, у якому можна знову довіряти — собі й життю.';
export const VICTORY_CENTER_BELIEF = {
    FIRST_LINE: 'У Victory Center ми віримо: зцілення починається не зі слів, а з тиші, ',
    SECOND_LINE: 'присутності й дотику до живого. Там, де можна видихнути. Там, де тебе бачать.',
};
export const MAIN_TITLE = {
    PREFIX: 'Ми створюємо ',
    FIRST_HIGHLIGHT: 'простори,',
    MIDDLE: ' де можливе ',
    SECOND_HIGHLIGHT: 'зцілення',
};
export const FAILED_TO_LOAD_THE_PROGRAMS = 'Не вдалося завантажити дані програм. Будь-ласка спробуйте пізніше.';
